import { Spinner } from '@/shared/ui/primitives';
import { useT } from '@/shared/i18n';
import type { ReactNode } from 'react';

/**
 * Shared `<Suspense>` fallback for lazy-loaded routes — a centered branded
 * spinner that fills the available height, so route transitions feel
 * intentional rather than a blank flash.
 */
export function SuspenseFallback(): ReactNode {
  const { t } = useT();
  return (
    <div
      className="flex min-h-[40vh] w-full flex-1 items-center justify-center text-[var(--text-muted)]"
      data-testid="route-loading"
    >
      <Spinner size={28} label={t('common.loading')} />
    </div>
  );
}
